import { fetchApi } from '../../../../lib/fetchApi';
import { ClientDto, ClientListFields } from '../types';
import { ExtractFnReturnType, QueryConfig } from '../../../../lib/react-query';
import { useQuery } from '@tanstack/react-query';
import { DeleteReasonDto } from '../../../../types/DeleteReasonDto';
import { Pagination } from '../../../../types/Pagination';

export const getClients = async (pageNumber: number, pageSize: number, filter: string): Promise<Pagination<ClientListFields>> => {
    const response = await fetchApi.get(`/client`, {
        params: {
            pageNumber,
            pageSize,
            filter
        }
    }) as Pagination<ClientListFields>;
    return response;
};

export const deleteLogicClient = async (clientId: number, body: DeleteReasonDto): Promise<void> => {
    
    await fetchApi.put(`/client/delete/${clientId}`, body);

};

export const getClientDetails = async (id: number): Promise<ClientDto> => {
    const data = await fetchApi.get(`/client/${id}`) as ClientDto;
    return data;
}

export const updateClient = async (idClient: string, body: ClientDto): Promise<ClientDto> => {
    const response = await fetchApi.put<ClientDto>(`/client/${idClient}`, body, {
        params: { idClient },
    });
    return response;
};

export const saveClient = async (
    body: ClientDto
): Promise<ClientDto> => {
    const response = await fetchApi.post('/client', body) as ClientDto;
    return response;
}

type QueryFnType = typeof getClients;

type UseClientsOptions = {
    config?: QueryConfig<QueryFnType>;
    pageNumber?: number;
    pageSize?: number;
    documentNumber?: "";
    name?: "";
};


export const useClient = ({
    config,
    pageNumber = 1,
    pageSize = 1,
    name = ""
}: UseClientsOptions = {}) => {


    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        queryKey: ["client"],
        queryFn: () => getClients(pageNumber, pageSize, name),
    });
}